<template>
  <v-card class="user-history" tile>
    <v-card-title>{{ showTitle }}</v-card-title>
    <div class="pa-2 pl-4">
      <!-- <v-row>
        <v-col cols="5">
          <v-text-field v-model="tCompVm" ref="inputText" class="w-auto" outlined dense required :rules="[() => !!tCompVm || this.$t('validation.required')]" @input="inputValue" :error="errorStatus"></v-text-field>
        </v-col>
      </v-row> -->
      <dl class="form-box">
        <dt class="d-table-cell pt-1">{{ this.$t('statistics.category') }}</dt>
        <dd class="d-table-cell">
          <div class="d-flex align-content-start flex-wrap">
            <span class="wrap-sts-chk">
              <v-text-field v-model="tCompVm" ref="inputText" class="w-auto" outlined dense required :rules="[() => !!tCompVm || this.$t('validation.required')]" @input="inputValue" :error="errorStatus"></v-text-field>
            </span>
          </div>
        </dd>
      </dl>
    </div>
  </v-card>
</template>

<script>
export default {
  components: {},
  props: {
    type: String,
  },
  data() {
    return {
      tCompVm: null,
      errorMessages: '',
      errorStatus: false,
    };
  },
  computed: {
    showTitle() {
      let title = '';
      if (this.type === 'user') {
        title = this.$t('statistics.user');
      } else if (this.type === 'report') {
        title = this.$t('statistics.report');
      } else {
        title = this.$t('statistics.tcode');
      }
      return title;
    },
  },
  watch: {
    type() {
      this.initValues();
    },
  },
  created() {
    this.initDefaultValue();
  },
  methods: {
    initValues() {
      this.tCompVm = null;
      this.errorStatus = false;
      this.$refs.inputText.resetValidation();
      this.initDefaultValue();
    },
    initDefaultValue(val = '') {
      this.$emit('changeCommon', { val: val, title: this.showTitle }, this.type);
    },
    inputValue(val) {
      this.initDefaultValue(val);
    },
  },
};
</script>
